/** @jsx jsx */
import { jsx } from "theme-ui"
import { Themed } from '@theme-ui/mdx'
import { Grid } from "@theme-ui/components"
import PropTypes from "prop-types"
import { rem } from "@src/theme"
import ButtonLink from "@components/ButtonLink"
import Banner from "@components/Banner"
const Testimonial = ({ heading, subheading, body, image, footnote = "", subtext, ctaButton }) => {
  const bottomText = footnote ? footnote : subtext || ''
  return (
    <Grid gap={[4, 7]} columns={[1, null, null, 2]}>
      <div
        sx={{
          height: [rem(250), rem(350), null, rem(509)],
          width: "100%",
        }}
      >
        <img src={image} className="object-fit" />
      </div>

      <div
      >


        <div>
          {heading && <Banner title={heading} small noUpperCase styles={{
            mb: rem(60)

          }} />}

          {subheading && <Themed.h3
            sx={{
              mb: 0,
              mt: 0,
              lineHeight: 1.1,
              textTransform: 'none'
            }}
          >
            {subheading}
          </Themed.h3>
          }
          <div sx={
            {
              mt: [4, null, rem(28)]
            }}>
            {body && (
              <p
                sx={{
                  mb: 0,
                  mt: rem(20),
                  fontSize: [rem(18), rem(22)],
                  fontWeight: 600
                }}
              >
                {body}
              </p>
            )}
            {bottomText && (
              <p
                sx={{
                  mt: 1,
                  mb: 0,
                  fontSize: [rem(18), rem(22)],
                  fontWeight: 500
                }}
              >
                {bottomText}
              </p>
            )}

            {ctaButton?.link && <ButtonLink styles={{
              mt: 7
            }} to={ctaButton.link}>{ctaButton.label}</ButtonLink>}
          </div>
        </div>
      </div>
    </Grid>
  )
}

export default Testimonial

Testimonial.propTypes = {
  heading: PropTypes.string,
  body: PropTypes.string,
  image: PropTypes.string,
  ctaButton: PropTypes.shape({
    label: PropTypes.string,
    link: PropTypes.string,
  })
}
